/**
 * Central registry of socket events that UFrameworkProvider can auto-fetch
 * once a socket session is established.
 *
 * Each product's App.jsx opts in by listing keys on the `autoFetch` prop:
 *
 *   <UFrameworkProvider value={...} autoFetch={['customFields']}>
 *
 * To enable an event for a new product, add the key to that product's
 * `autoFetch` prop. To add a new shared event, add an entry below — every
 * product that opts in then receives it without duplicating wiring.
 */
export const AUTO_FETCH_EVENTS = {
    customFields: {
        event: 'hrms|master|customFieldsData|read',
        payload: {},
        action: 'SET_ALL_FIELDS',
    },
};
